import styled from 'styled-components'

const BaseLabel = styled.text`
  font-family: var(--font-sans-serif);
`

export const LabelUnimportant = styled(BaseLabel)`
  font-size: 13px;
  font-weight: 300;
  fill:var(--gray-3);
  @media screen and (max-width: 900px) {
    font-size: 11px;
  }
`
export const LabelUnimportantInverted = styled(BaseLabel)`
  font-size: 13px;
  font-weight: 300;
  fill:white;
  @media screen and (max-width: 900px) {
    font-size: 11px;
  }
`
export const SmallLabel = styled(BaseLabel)`
  font-size: 15px;
  font-weight: 600;
  fill:var(--gray-2);
  @media screen and (max-width: 900px) {
    font-size: 12px;
  }
`

export const Capital = styled(BaseLabel)`
  font-size: 15px;
  font-weight: 700;
`

export const Country = styled(BaseLabel)`
  font-size: 18px;
  font-weight: 300;
  font-style: italic;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  @media screen and (max-width: 900px) {
    font-size: 14px;
  }
`
export const CountrySmall = styled(BaseLabel)`
  font-size: 15px;
  font-weight: 300;
  font-style: italic;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  fill: rgba(0, 0, 0, 0.4);
 
`
export const Region = styled(BaseLabel)`
  font-size: 15px;
  font-weight: 400;
  font-style: italic;
  letter-spacing: 1.5px;
  font-family: var(--font-serif);
  fill: rgba(0, 0, 0, 0.3);

  @media screen and (max-width: 900px) {
    font-size: 13px;
  }
`
export const RegionInverted = styled(BaseLabel)`
  font-size: 18px;
  font-weight: 400;
  font-style: italic;
  letter-spacing: 1.5px;
  font-family: var(--font-serif);
  fill: rgba(255, 255, 255, 0.8);
  @media screen and (max-width: 900px) {
    font-size: 13px;
  }
`
export const SatAnnotationYellow = styled(BaseLabel)`
  font-size: 15px;
  fill: var(--yellow-main);
  text-shadow: 0px 0px 6px #000000;
`
export const SatAnnotationWhite = styled(BaseLabel)`
  font-size: 15px;
  text-shadow: 0px 0px 6px #000000;
  fill: white;
  font-weight: 600;
`
export const SatAnnotationGray = styled(BaseLabel)`
  font-size: 15px;
  fill: var(--gray-3);
`
export const SatAnnotationText = styled(BaseLabel)`
  font-size: 18px;
  fill: white;
  font-family: var(--font-serif);
  text-shadow: 0px 0px 6px #000000, 0px 0px 6px #000000;

  @media screen and (max-width: 950px) {
    font-size: 15px;
  }
`